/**
 * categoryStyle.js — rail style resolution shared by the homepage, Movies and Series pages.
 *
 * Rail styles such as `top-number-poster` (the numbered Top 10 rails) are set by the backend,
 * usually as a `style` entry in the category's `custom_fields`. If a page drops the style when
 * it builds its categories, the rail renders as a plain rail with no 1-10 numbers.
 */

/** Style for a raw API category: `custom_fields` entry first, then the `style` property. */
export function resolveCategoryStyle(category) {
  const fields = Array.isArray(category?.custom_fields) ? category.custom_fields : [];
  const styleField = fields.find(field => field?.field_title === 'style');
  if (styleField?.field_value) {
    return styleField.field_value;
  }
  return category?.style || undefined;
}

/**
 * Backend rail styles are shared with the apps. On the web, numbered rails use the same 16:9
 * thumbnails as every other rail, so the poster variant is shown as the 16:9 `top-number`.
 */
const WEB_RAIL_STYLES = { 'top-number-poster': 'top-number' };

/** Style the web should render for a raw API category. */
export function resolveRailStyle(category) {
  const style = resolveCategoryStyle(category);
  return WEB_RAIL_STYLES[style] || style;
}

/** Category shape used by the Movies and Series pages from a `{ category, channels }` API item. */
export function toRailCategory(item) {
  return {
    _id: item.category._id,
    name: item.category.name,
    display_name: item.category.name,
    channels: item.channels || [],
    slug: item.category.slug,
    style: resolveRailStyle(item.category),
  };
}
